import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { EditarDocumentoCompraSkeleton } from "@/features/admin-compras-shared/EditarDocumentoCompraSkeleton";
import { AdminEditarContratoPage } from "@/features/admin-contratos-anualizados/components/AdminEditarContratoPage";
import { contratoAdminQueryOptions } from "@/features/admin-contratos-anualizados/hooks/use-contratos";

export const Route = createFileRoute("/_authed-tw/admin/contratos-anualizados/$id")({
  loader: ({ context: { queryClient }, params: { id } }) =>
    tienePermisoEnSesion([PERMISOS.adminComprasSap])
      ? queryClient.ensureQueryData(contratoAdminQueryOptions(id))
      : undefined,
  pendingComponent: EditarDocumentoCompraSkeleton,
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminComprasSap]}>
      <AdminEditarContratoPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
